// extracted by mini-css-extract-plugin
module.exports = {"page":"ApplyList_page__2p1mI","subBtnStyle":"ApplyList_subBtnStyle__dMN3z","inputStyle":"ApplyList_inputStyle__11aW7"};